// Team Page
export default function Team() { return <div><h1 className="text-4xl font-bold text-center py-20">Our Team</h1><p className="text-center">Meet our coaches and staff.</p></div>; }